import React, { useEffect, useState } from 'react'
import { Row, Col, MultiCascader } from 'rsuite'
import { requiredFiled, isValidators } from '../../../utils/ValidatorUtils'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'

export default function InputMultiCascaderForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  index,
  cascaderDatas,
  uncheckableItems,
  menuWidth = 220,
  menuHeight = 200,
  onChange = () => {},
  ...props
}) {
  const keyName = props?.name || schema?.name
  const labelMdLg = props.labelMdLg || 24
  const inputMdlg = props.inputMdlg || 24
  const disabled = props.disabled || schema?.disabled || false
  const [inputValue, setInputValue] = useState(props.value || schema?.value || '')
  const placeholder = props.placeholder || schema?.hint || 'ระบุ ' + schema?.label
  const datas = cascaderDatas || schema?.datas || schema?.options || []

  useEffect(() => {
    setInputValue(props.value || schema?.value || '')
  }, [props.value, schema])

  return (
    <>
      {schema && (
        <Row style={{ ...props.style }}>
          {errors[keyName] && (
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <ErrorMessage error={errors[keyName]} />
            </Col>
          )}

          {!props.hideLabel && schema.label && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <p>{requiredFiled(schema.validators, `${schema.label} ${index || ''}`)}</p>
            </Col>
          )}
          {schema.description && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <CustomIconMessageInfo style={{ marginBottom: 10 }} contents={schema.description} />
            </Col>
          )}
          <Col xs={24} sm={24} md={inputMdlg} lg={inputMdlg} style={{ marginTop: 5 }}>
            <Controller
              key={keyName}
              name={keyName}
              control={control}
              rules={isValidators(schema.validators)}
              defaultValue={inputValue}
              render={(props) => {
                return (
                  <MultiCascader
                    size="lg"
                    block
                    menuHeight={menuHeight}
                    menuWidth={menuWidth}
                    data={datas}
                    value={inputValue}
                    disabled={disabled}
                    onChange={(value) => {
                      props.onChange(value)
                      onChange(value)
                      setInputValue(value)
                    }}
                    // uncheckableItemValues
                    uncheckableItemValues={uncheckableItems || schema.unSelected || []}
                    placeholder={placeholder}
                    renderValue={(value, selectedItems) => {
                      return <span>{selectedItems.map((item) => item.label).join(' , ')}</span>
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
      )}
    </>
  )
}
